import { api } from '@/services/axios'

export interface UpdateCampaignBody {
  id: number
  titulo: string
  titulo_quantidade: number
  titulo_valor: number
  descricao: string
  prazo_id: number
  titulo_min: number
  titulo_max: number
  modo_id: number
  dt_sorteio?: string
  imagemFile?: File
  notificar_grupo_whatsapp?: boolean
  nome_grupo_whatsapp?: string
}

export async function updateCampaign(data: UpdateCampaignBody) {
  const formData = new FormData()

  formData.append('Id', String(data.id))
  formData.append('Titulo', data.titulo)
  formData.append('Titulo_Quantidade', String(data.titulo_quantidade))
  formData.append('Titulo_Valor', String(data.titulo_valor)) // Corrigido o nome do campo
  formData.append('Descricao', data.descricao)
  formData.append('Prazo_Id', String(data.prazo_id))
  formData.append('Titulo_Min', String(data.titulo_min))
  formData.append('Titulo_Max', String(data.titulo_max))
  formData.append('Modo_Id', String(data.modo_id))

  if (data.dt_sorteio) {
    formData.append('Dt_Sorteio', data.dt_sorteio)
  }

  if (data.imagemFile) {
    formData.append('Imagem', data.imagemFile)
  }

  formData.append(
    'notificar_grupo_whatsapp',
    data.notificar_grupo_whatsapp ? 'true' : 'false',
  )
  formData.append('nome_grupo_whatsapp', data.nome_grupo_whatsapp || '')

  try {
    await api.put(`Campanha/Update/${data.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    console.error('Erro ao atualizar a campanha:', error)
    throw error
  }
}
